import { StoreObject, gql, useApolloClient, useMutation } from '@apollo/client';
import { useEmployee, useLoginInput } from 'hooks';

const SAVE_INTERESTS = gql`
  mutation SaveInterests($interests: InterestsInput!) {
    saveInterests(interests: $interests) {
      login
      interests
    }
  }
`;

type SaveInterestsReturnType = {
  saveInterests: {
    login: string;
    interests: string;
  };
};

export const useSaveInterests = (): ((interests: string) => Promise<void>) => {
  const loginInput = useLoginInput();
  const { employee } = useEmployee();
  const client = useApolloClient();
  const [saveInterests] = useMutation(SAVE_INTERESTS, {
    onCompleted(data: SaveInterestsReturnType) {
      client.cache.modify({
        fields: {
          interests() {
            return data.saveInterests.interests;
          },
        },
        id: client.cache.identify(employee as unknown as StoreObject),
      });
    },
  });

  return async (interests: string) => {
    const opt = { variables: { interests: { ...loginInput, interests } } };

    await saveInterests(opt);
  };
};
